import type { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './components/organisms/AppRouter';
import KhaltiTopupModal from './components/organisms/KhaltiTopupModal';
import './App.css';

// Light is the default for the Khalti modal. ?theme=dark flips to the dark variant.
const resolveModalTheme = (): 'dark' | 'light' => {
  if (typeof window === 'undefined') return 'light';
  const param = new URLSearchParams(window.location.search).get('theme');
  return param === 'dark' ? 'dark' : 'light';
};

const App: FC = () => {
  return (
    <BrowserRouter>
      <AppRouter />
      <KhaltiTopupModal theme={resolveModalTheme()} />
    </BrowserRouter>
  );
};

export default App;
